import { Injectable } from '@angular/core';
import { recoverAccountView } from '@com-delta-idp/mnx-login-ui';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RecoverYourAccountAdapterService } from '../../adapters/recover-your-account-adapter/recover-your-account-adapter.service';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import { VIEW_NAME } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';
import { ResetPasswordEmailLinkResponse } from '../../models/reset-password-api.interface';
import {
  NextDisplayViewService,
  ResetPasswordApiService
} from '../../services';
import { LoginContentService } from '../../services/login-content.service';
import { CreateMyPasswordFacade } from '../create-my-password/create-my-password.facade';

@Injectable({
  providedIn: 'root'
})
export class RecoverYourAccountFacadeService {
  pageContent$ = new BehaviorSubject<recoverAccountView | undefined>(undefined);
  emailExpired$ = new BehaviorSubject<boolean>(false);
  aemContent!: LoginModalContent;
  unsubscribe$ = new Subject();

  constructor(
    private loginContentService: LoginContentService,
    private recoverYourAccountAdapterService: RecoverYourAccountAdapterService,
    private resetPasswordApiService: ResetPasswordApiService,
    private nextDisplayView: NextDisplayViewService,
    private createMyPasswordFacade: CreateMyPasswordFacade,
    private analytics: AnalyticsService
  ) {
    this.getRecoverYourAccountPageContent();
  }

  getRecoverYourAccountPageContent() {
    this.loginContentService.getAEMContent().subscribe((response) => {
      this.aemContent = response;
      this.pageContent$.next(
        this.recoverYourAccountAdapterService.getRecoverYourAccountScreenContent(
          this.aemContent
        )
      );
    });
  }

  initiateShowResetPassword() {
    this.resetPasswordApiService
      .showResetPassword(this.getRefParams())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (this.checkErrorResetPassword(res)) {
          this.emailExpired$.next(true);
          this.analytics.dispatchCustomEvent(
            ANALYTICS_EVENTS_LOGIN.RECOVERY_ACCOUNT_LOADED,
            true
          );
          this.nextDisplayView.nextDisplayView(
            VIEW_NAME.RECOVER_ACCOUNT_SCREEN
          );
        }

        if (res.isSuccess) {
          this.createMyPasswordFacade.userName = res.userName ?? '';
          this.createMyPasswordFacade.resetForm();
          this.analytics.dispatchCustomEvent(
            ANALYTICS_EVENTS_LOGIN.SET_PASSWORD_LOADED,
            true
          );
          this.nextDisplayView.nextDisplayView(VIEW_NAME.SET_PASSWORD_SCREEN);
        }
      });
  }

  checkErrorResetPassword(res: ResetPasswordEmailLinkResponse): boolean {
    return !!(res.errors && res.errors[0].code);
  }

  getRefParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const refLink = urlParams.get('refLink') ?? '';
    const refKey = urlParams.get('refKey') ?? '';
    return { refLink, refKey };
  }
}
